const stringToTimestamp = (oldDate: string) => {
  const newDate: string[] = oldDate.split("/");
  const newTimestamp = new Date(
    Number(newDate[0]),
    Number(newDate[1]) - 1,
    Number(newDate[2])
  );
  return newTimestamp;
};

const convertExcelDate = (date: number) => {
  const timestamp = new Date(Math.floor(date - 25569) * 86400000);
  const convertedDate = timestamp
    .toISOString()
    .split("T")[0]
    .replaceAll("-", "/");
  return convertedDate;
};

const changeDateOrder = (date: string) => {
  return (
    date.split("/")[2] + "/" + date.split("/")[0] + "/" + date.split("/")[1]
  );
};

const dateToString = (date: Date) => {
  return (
    date.getFullYear() +
    "/" +
    Number(date.getMonth() + 1) +
    "/" +
    date.getDate()
  );
};

const firebaseDateToString = (date: any) => {
  return date.toDate().toISOString().substring(0, 10).replaceAll("-", "/");
};

const getFirstDateOfMonth = (date: Date) => {
  const year = date.getFullYear();
  const month = date.getMonth();
  const firstDate = new Date(year, month, 1);
  const firstDateString = firstDate.toISOString().substring(0, 10);
  return firstDateString;
};

const getOneMonthBefore = (newDate: Date): Date =>
  new Date(newDate.setMonth(new Date().getMonth() - 1));

const getLastDateOfMonth = (date: Date) => {
  const year = date.getFullYear();
  const month = date.getMonth();
  const lastDate = new Date(year, month + 1, 1);
  lastDate.setDate(lastDate.getDate() - 1);
  const lastDateString = lastDate.toISOString().substring(0, 10);
  return lastDateString;
};

const getThisMonth = () => {
  const now = new Date();
  const date = now.toISOString().split("-");
  date.pop();
  return date.join("-");
};

const getLastMonth = () => {
  const now = new Date();
  const date = new Date(now.setMonth(now.getMonth() - 1))
    .toISOString()
    .split("-");
  date.pop();
  return date.join("-");
};

export {
  stringToTimestamp,
  convertExcelDate,
  changeDateOrder,
  dateToString,
  firebaseDateToString,
  getFirstDateOfMonth,
  getLastDateOfMonth,
  getThisMonth,
  getLastMonth,
  getOneMonthBefore,
};
